import enUS from './locales/en-US.json';
import esUS from './locales/es-US.json';
import zhCN from './locales/zh-CN.json';

export const DEFAULT_LOCALE = 'en-US' as const;

export const SUPPORTED_LOCALES = ['en-US', 'es-US', 'zh-CN'] as const;

export type LocaleCode = (typeof SUPPORTED_LOCALES)[number];

export type Messages = typeof enUS;

export const catalogs: Record<LocaleCode, Messages> = {
  'en-US': enUS,
  'es-US': esUS,
  'zh-CN': zhCN,
};

export const LOCALE_LABELS: Record<LocaleCode, string> = {
  'en-US': 'English (US)',
  'es-US': 'Español (US)',
  'zh-CN': '中文 (简体)',
};
